import * as Sentry from "@sentry/react";

export const StafferPetSafetyBoundary = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  /* Render */
  const render = () => {
    return (
      <Sentry.ErrorBoundary
        fallback={<></>}
        beforeCapture={(scope) => {
          scope.setTag("feature", "staffer-pets");
        }}
      >
        {children}
      </Sentry.ErrorBoundary>
    );
  };

  return render();
};
